module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAMAAACzvE1FAAAAWlBMVEVMaXGIjp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp9ApasaAAAAHXRSTlMARyRxB+fr+fUrpruxC+EOQczOhsIanO5Ij2WBf/b3AMkAAACWSURBVHjaVY5ZEoQgDERbRETBfUNnuP81JwloOe8jdBdJOiC6y/fW9v7qIIQqZqogvo4PdQEM8n84d0jPgJLfk6a7k1UJR7WF0JJ04IkGQkOyB6/UEDSvhfnvMFip7hB2kmtKWTSgl5SyRcZ4b0RsEpbJB6j36QrEJz58U/x8+0lDUCZ5o5AZLXs74qGw5ANeNPOU7/8Bu2gTXwEmZOoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/ic_adress.png
// module id = puZO
// module chunks = 9